import { formatAddressName } from '../lib/utils';

export interface IK2ViewInteraction {
  addressId: string;
  address: IK2ViewAddress;
  characteristic: IK2ViewCharacteristic;
  id: string;
}

export interface IK2ViewAddress {
  addressId: string;
  unit: string;
  floor: string;
  streetNumberPrefix: string;
  streetNumber: string;
  streetNumberSuffix: string;
  dirPrefix: string;
  streetTypePrefix: string;
  streetName: string;
  streetTypeSuffix: string;
  dirSuffix: string;
  city: string;
  province: string;
  postalCode: string;
  buildingType: string;
  projectSubType: string;
  locationComments: Ik2ViewLocationComments;
}

interface Ik2ViewLocationComments {
  addressComment: string;
  fibreComment: string;
  hazardComment: string;
}

export interface IK2ViewCharacteristic {
  coid: string;
  firstNationInd: boolean;
  premiseType: string;
  knockStatus: string;
  fibreServingArea: string; // THIS IS 'FSA'
  fibreDropStatus: string;
  fibreDropPermission: string;
  fibreDropPermissionStatus: string;
  doNotKnockInd: boolean;
  sellDecision: string;
  fmsId: string;
  fibreDropType: string;
  fsaReadyDate: Date;
  fibreDropCompletionDate: Date;
  serviceAddress: string;
  postalForwardSortationArea: string;
}

export class K2ViewInteraction implements IK2ViewInteraction {
  address: IK2ViewAddress;
  addressId: string;
  characteristic: IK2ViewCharacteristic;
  id: string;

  constructor(k2viewInteraction: IK2ViewInteraction) {
    this.address = k2viewInteraction.address;
    this.addressId = k2viewInteraction.addressId;
    this.characteristic = k2viewInteraction.characteristic;

    if (this.characteristic !== undefined) {
      this.characteristic.serviceAddress = formatAddressName(this.address);
    }
  }
}
